// extracted by mini-css-extract-plugin
export default {"title":"De5g4OvT"};